import { StreamActions } from "@hotwired/turbo"

StreamActions.set_value = function () {
  const target = this.targetElements[0];
  if (target) {
    target.value = this.getAttribute('value');
  }
};
